import React from "react";
import { useBranch } from "@/context/BranchContext";
import { Store, ChevronDown } from "lucide-react";

export default function BranchSelector() {
  const { branches, activeId, setActive } = useBranch();
  if (branches.length === 0) return null;
  return (
    <div className="relative">
      <div className="flex items-center gap-1.5 border border-zinc-300 bg-white px-2 py-1.5 text-xs">
        <Store className="w-3.5 h-3.5 text-zinc-500" />
        <select
          data-testid="branch-selector"
          value={activeId}
          onChange={(e) => setActive(e.target.value)}
          className="font-mono text-xs bg-transparent focus:outline-none pr-2"
        >
          {branches.map((b) => (
            <option key={b.id} value={b.id}>{`${b.code} · ${b.name}`}</option>
          ))}
        </select>
        <ChevronDown className="w-3 h-3 text-zinc-400 -ml-2 pointer-events-none" />
      </div>
    </div>
  );
}
